<template>
  <v-app-bar
    :color="!isStandalone ? (isStaging ? 'orange' : 'blue') : 'white'"
    :dark="!isStandalone"
    :elevation="!isStandalone ? 0 : null"
    fixed
    clipped-left
    app
  >
    <v-btn
      v-if="prevRoute"
      icon
      @click="$router.push($routerHistory.hasPrevious() ? $routerHistory.previous().path : prevRoute)"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-app-bar-nav-icon v-else-if="showDraweToggle" @click="toggleDrawer"></v-app-bar-nav-icon>

    <v-toolbar-title v-if="title" :class="{ 'ml-0': prevRoute || toggleDrawer }">{{ title }}</v-toolbar-title>
    <v-row v-else no-gutters align="end">
      <img src="https://file.usail.es/static/connect-logo-white.svg" alt="USAIL Connect" style="max-width: 140px" />
      <div v-if="isStaging" class="caption ml-1 white--text" style="margin-bottom: -2px">Staging</div>
    </v-row>

    <v-spacer></v-spacer>

    <ToolbarNotifications></ToolbarNotifications>
    <ToolbarApps v-if="!isStandalone"></ToolbarApps>
    <ToolbarUser v-if="$keycloak.authenticated"></ToolbarUser>

    <v-progress-linear v-show="loading" indeterminate absolute bottom style="bottom: -4px"></v-progress-linear>
  </v-app-bar>
</template>

<script>
import ToolbarUser from '@/components/ToolbarUser'
import ToolbarApps from '@/components/ToolbarApps'
import ToolbarNotifications from '@/components/ToolbarNotifications'

export default {
  components: {
    ToolbarUser,
    ToolbarApps,
    ToolbarNotifications
  },

  props: {
    prevRoute: {
      type: Object,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    showDraweToggle: {
      type: Boolean,
      required: false,
      default: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      isStaging: window.location.hostname.includes('staging')
    }
  },

  computed: {
    isStandalone() {
      return window.matchMedia('(display-mode: standalone)').matches
    }
  },

  methods: {
    toggleDrawer: function() {
      this.$store.commit('drawerSetStatus', !this.$store.state.drawer.status)
    }
  }
}
</script>
